export default "__VITE_ASSET__1e4f384c__"